import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { HttpEventType, HttpClient } from "@angular/common/http";
import { LeadSubmit } from "../models/call-center.model";
import { Observable } from "rxjs";
import { PostResponse } from "../models/common-model";
import {
  PackageEnquiryStatusCount,
  PostGetLeadSourceRevenueDataRequest,
  PostSetTargets,
  PostSetTargetsDigitalMIS,
  PostSetTargetsToLeadSource,
  SetTargets,
  SetTargetsToLeadSources,
} from "../models/reports.model";
@Injectable({
  providedIn: "root",
})
export class ReportsService {
  constructor(private http: HttpClient) {}

  getAllTargetedList() {
    return this.http.get<SetTargets>(
      environment.apiUrl + "Reports/GetAllTargetedReportsData/"
    );
  }

  setRevenueTargetData(payload: PostSetTargets): Observable<PostResponse> {
    return this.http.post<PostResponse>(
      `${environment.apiUrl}Reports/SetRevenueTargets/`,
      payload
    );
  }

  getAllTargetedToLeadSourceList() {
    return this.http.get<SetTargetsToLeadSources>(
      environment.apiUrl + "Reports/GetAllTargetsToLeadSourcesReportsData/"
    );
  }
  getAllTargetedDigitalMIS(RowsCount, PageNo, FromDate, ToDate, clinicType) {
    return this.http.get(
      `${environment.apiUrl}CallCenter/GetDigitalMISTargetDetails/?RowsCount=${RowsCount}&PageNo=${PageNo}&FromDate=${FromDate}&ToDate=${ToDate}&clinicType=${clinicType}`
    );
  }

  setRevenueTargetToLeadSourceData(
    payload: PostSetTargetsToLeadSource
  ): Observable<PostResponse> {
    return this.http.post<PostResponse>(
      `${environment.apiUrl}Reports/SetRevenueTargetsToLeadSources/`,
      payload
    );
  }

  setRevenueTargetToDigitalMIS(payload): Observable<PostResponse> {
    return this.http.put<PostResponse>(
      `${environment.apiUrl}CallCenter/InsertDigitalMISTargetDetails/`,
      payload
    );
  }

  updateRevenueTargetToDigitalMIS(payload, targetId): Observable<PostResponse> {
    return this.http.post<PostResponse>(
      `${environment.apiUrl}CallCenter/UpdateDigitalMISTargetDetails/${targetId}`,
      payload
    );
  }

  getDigitalMISAchievementDateBUWise(FromDate, ToDate, LeadSource) {
    return this.http.get(
      `${environment.apiUrl}Reports/GetDigitalMISAchievementLeadsDataBUWise/?FromDate=${FromDate}&ToDate=${ToDate}&LeadSource=${LeadSource}`
    );
  }
  getDigitalMISLeadsAppointmentCount(FromDate, ClinicType, LeadSource) {
    return this.http.get(
      `${environment.apiUrl}Reports/GetDigitalMISLeadsAppointmentCount/?FromDate=${FromDate}&ClinicType=${ClinicType}&LeadSource=${LeadSource}`
    );
  }

  getDigitalMISAchievementLeadsGraphDataBUWise(
    ActiveDate,
    PreviousDate,
    PastYearDate,
    ClinicType,
    LeadSource
  ) {
    return this.http.get(
      `${environment.apiUrl}Reports/GetDigitalMISAchievementLeadsGraphDataBUWise/?ActiveDate=${ActiveDate}&PreviousDate=${PreviousDate}&PastYearDate=${PastYearDate}&ClinicType=${ClinicType}&LeadSource=${LeadSource}`
    );
  }

  getDigitalMISAchievementDetails(FromDate, ToDate, LeadSource) {
    return this.http.get(
      `${environment.apiUrl}CallCenter/GetDigitalMISAchievementDetails/?FromDate=${FromDate}&ToDate=${ToDate}&LeadSource=${LeadSource}`
    );
  }

  getLeadSourceRevenueReportData(
    payload: PostGetLeadSourceRevenueDataRequest
  ): Observable<PostResponse> {
    return this.http.post<PostResponse>(
      `${environment.apiUrlV2}Reports/GenerateLeadSourceReport/`,
      payload
    );
  }

  getFeedbackReportData() {
    return this.http.get<PostResponse>(
      environment.apiUrl + "Reports/GetFeedbackReportDataFromApollo/"
    );
  }

  GetAllLeadsAndActivityLeadsDashboardData() {
    return this.http.get<PostResponse>(
      environment.apiUrl + "Reports/GetAllLeadsAndActivityLeadsDashboardData/"
    );
  }

  GetAllLeadsCountCustom(payload) {
    return this.http.post<PostResponse>(
      environment.apiUrl +
        "Reports/GetAllLeadsAndActivityLeadsDashboardCustom/",
      payload
    );
  }

  GetAllCallCenterReportData(payload) {
    return this.http.post(
      environment.apiUrl + "Reports/GetAppointmentReport",
      payload
    );
  }

  getCallHistoryExcelData(payload) {
    return this.http.post(
      environment.apiUrl + "Reports/CallHistoryInfoReport",
      payload,
      { responseType: "blob" }
    );
  }

  getNPSReportExcelData(payload) {
    return this.http.post(
      environment.apiUrl + "Reports/FeedbackFormReport",
      payload,
      { responseType: "blob" }
    );
  }

  getUserLogsReportData(payload) {
    return this.http.post(
      environment.apiUrl + "Reports/UserLogsReport/",
      payload,
      { responseType: "blob" }
    );
  }

  getConfirmLeadsReport(payload) {
    return this.http.post(
      environment.apiUrl + "Reports/ConfirmedLeadsReport",
      payload,
      { responseType: "blob" }
    );
  }

  getTeleVirtualReport(payload) {
    return this.http.post(
      environment.apiUrl + "Reports/TeleConsultationLeadsReport",
      payload,
      { responseType: "blob" }
    );
  }

  getWalkinReport(payload) {
    return this.http.post(
      environment.apiUrl + "Reports/WalkinLeadsReport",
      payload,
      { responseType: "blob" }
    );
  }
  getRescheduledLeadsReport(payload) {
    return this.http.post(
      environment.apiUrl + "Reports/ReschedulingLeadsReport",
      payload,
      { responseType: "blob" }
    );
  }

  getHealthCheckReport(payload) {
    return this.http.post(
      environment.apiUrl + "Reports/HealthCheckReport",
      payload,
      { responseType: "blob" }
    );
  }

  getCorpHealthCheckReport(payload) {
    return this.http.post(
      environment.apiUrl + "Reports/CorpHealthCheckReport",
      payload,
      { responseType: "blob" }
    );
  }

  getPackageEnquiryLeadsCount(): Observable<PackageEnquiryStatusCount[]> {
    return this.http.get<PackageEnquiryStatusCount[]>(
      `${environment.apiUrl}CallCenter/GetPackageEnquiryLeadsCount`
    );
  }

  GetAllCallCenterExcelData(payload) {
    return this.http.post(
      environment.apiUrl + "Reports/DownloadAppointmentReport",
      payload,
      { responseType: "blob" }
    );
  }

  getCradleHeaders() {
    return [
      { field: "Maternity", header: "Maternity", display: "table-cell" },
      { field: "Gynecology", header: "Gynecology", display: "table-cell" },
      { field: "Pediatrics", header: "Pediatrics", display: "table-cell" },
      { field: "City", header: "City", display: "table-cell" },
    ];
  }

  getFertilityHeaders() {
    return [
      { field: "IVF", header: "IVF", display: "table-cell" },
      { field: "IUI", header: "IUI", display: "table-cell" },
      { field: "Others", header: "Others", display: "table-cell" },
      { field: "City", header: "City", display: "table-cell" },
    ];
  }

  getSpectraHeaders() {
    return [
      {
        field: "GeneralSurgery",
        header: "General Surgery",
        display: "table-cell",
      },
      { field: "Ortho", header: "Ortho", display: "table-cell" },
      { field: "VV", header: "VV", display: "table-cell" },
      { field: "Others", header: "Others", display: "table-cell" },
      { field: "City", header: "City", display: "table-cell" },
    ];
  }

  getDiagnosticHeaders() {
    return [
      { field: "RTPCR", header: "RTPCR", display: "table-cell" },
      { field: "Test", header: "Test", display: "table-cell" },
      { field: "Package", header: "Package", display: "table-cell" },
      { field: "City", header: "City", display: "table-cell" },
    ];
  }

  getClinicHeaders() {
    return [
      { field: "HC", header: "HC", display: "table-cell" },
      { field: "Consult", header: "Consult", display: "table-cell" },
      { field: "Test", header: "Test", display: "table-cell" },
    ];
  }

  getSugarHeaders() {
    return [
      { field: "LTP", header: "LTP", display: "table-cell" },
      { field: "Consult", header: "Consult", display: "table-cell" },
      { field: "Test", header: "Test", display: "table-cell" },
    ];
  }

  getDentalHeaders() {
    return [
      { field: "Consult", header: "Consult", display: "table-cell" },
      { field: "Procedure", header: "Procedure", display: "table-cell" },
      { field: "Others", header: "Others", display: "table-cell" },
    ];
  }

  getDialysisHeaders() {
    return [
      { field: "Consult", header: "Consult", display: "table-cell" },
      { field: "City", header: "City", display: "table-cell" },
    ];
  }

  GetAllTIMLReportData(payload) {
    return this.http.post(
      environment.apiUrl + "Reports/GetTIMLReport",
      payload
    );
  }

  GetAllTIMLReportExcelData(payload) {
    return this.http.post(
      environment.apiUrl + "Reports/DownloadTIMLReport",
      payload,
      { responseType: "blob" }
    );
  }

  DownloadLeadsReport(payload) {
    return this.http.post(
      environment.apiUrl + "Reports/DownloadLeadsReport",
      payload,
      { responseType: "blob" }
    );
  }

  DownloadInboundReportData(payload) {
    return this.http.post(
      environment.apiUrl + "Reports/InboundCallReport",
      payload,
      { responseType: "blob" }
    );
  }
}
